import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { CartProvider } from "./contexts/CartContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import AuthCallback from "./components/AuthCallback";
import ProtectedRoute from "./components/ProtectedRoute";
import LogoIntro from "./components/LogoIntro";
import CookieBanner from "./components/CookieBanner";
import Home from "./pages/Home";
import ChiSiamo from "./pages/ChiSiamo";
import Prodotti from "./pages/Prodotti";
import Servizi from "./pages/Servizi";
import Marchi from "./pages/Marchi";
import Contatti from "./pages/Contatti";
import Checkout from "./pages/Checkout";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import CategoriesAdmin from "./pages/CategoriesAdmin";
import BrandsAdmin from "./pages/BrandsAdmin";
import ControlPanel from "./pages/ControlPanel";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import TerminiCondizioni from "./pages/TerminiCondizioni";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function AppRouter() {
  const location = useLocation();
  
  // Track page visits
  useEffect(() => {
    const trackVisit = async () => {
      try {
        await fetch(`${BACKEND_URL}/api/analytics/track-visit`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            page_url: location.pathname,
            referrer: document.referrer
          })
        });
      } catch (error) {
        // Silently fail - don't block page load
      }
    };
    
    trackVisit();
  }, [location.pathname]);
  
  // Check URL fragment (not query params) for session_id
  // This MUST happen during render, not in useEffect, to prevent race conditions
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <>
      <Header />
      <main className="pt-[120px]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/chi-siamo" element={<ChiSiamo />} />
          <Route path="/prodotti" element={<Prodotti />} />
          <Route path="/servizi" element={<Servizi />} />
          <Route path="/marchi" element={<Marchi />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/checkout" element={<Checkout />} />
          
          {/* Legal Pages */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/termini-e-condizioni" element={<TerminiCondizioni />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route 
            path="/admin/dashboard" 
            element={
              <ProtectedRoute requireAdmin>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/categories" 
            element={
              <ProtectedRoute requireAdmin>
                <CategoriesAdmin />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/brands" 
            element={
              <ProtectedRoute requireAdmin>
                <BrandsAdmin />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/controllo" 
            element={
              <ProtectedRoute requireAdmin>
                <ControlPanel />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute requireAdmin>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </main>
      <Footer />
      <Toaster position="top-right" />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <LogoIntro />
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <AppRouter />
            <CookieBanner />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
